import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2180577564/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/product/[id]/_components/product.tsx");
